import { NylasListConnectionsResponseContent } from "@equaliq/api-model-v2";
import { createApiRequest } from "../common";

/**
 * API function to list all Nylas connections for authenticated user
 * @returns Promise with connection status and list of connections
 */
export const listIntegrationConnectionsApi = async (): Promise<NylasListConnectionsResponseContent> => {
  const apiRequest = createApiRequest<NylasListConnectionsResponseContent>('post', '/integrations/nylas/connections/list');
  return apiRequest({});
};
